"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page",
    on: {
      scroll: _vm.handleScroll
    }
  }, [_c("div", {
    staticClass: "side-nav",
    class: {
      "is-black": [1, 5, 7].includes(_vm.currentSection)
    }
  }, _vm._l(_vm.navItems, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "nav-item",
      class: {
        active: _vm.currentSection === index
      },
      on: {
        click: function click($event) {
          return _vm.scrollToSection(index);
        }
      }
    }, [_vm._m(0, true), _c("div", {
      staticClass: "nav-text"
    }, [_vm._v(_vm._s(item))])]);
  }), 0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8)]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "nav-icon"
  }, [_c("div", {
    staticClass: "dot"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page-box section",
    attrs: {
      "data-section": "0"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88banner.png"
    }
  }), _c("div", {
    staticClass: "page-title"
  }, [_c("div", {
    staticClass: "title-box"
  }, [_c("span", {
    staticClass: "title-item item_right"
  }, [_vm._v("商务解决方案")])]), _c("div", {
    staticClass: "title-sub margin-bottom-20"
  }, [_vm._v("多场景商务赋能 提升核心竞争力")])])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-2",
    attrs: {
      "data-section": "1"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/1%E4%BF%9D%E9%99%A9%E6%9C%8D%E5%8A%A1.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-3",
    attrs: {
      "data-section": "2"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/2%E4%BF%9D%E8%B4%B9%E9%80%9A.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-4",
    attrs: {
      "data-section": "3"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/3%E8%BD%A8%E8%BF%B9%E5%AE%9A%E4%BD%8Dnew.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section section-5",
    attrs: {
      "data-section": "4"
    }
  }, [_c("img", {
    staticClass: "bg-img",
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/4%E5%9F%8E%E5%B8%82%E5%90%88%E4%BC%99%E4%BA%BAnew.png"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section bottom-img section-6",
    attrs: {
      "data-section": "5"
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/5%E4%BC%81%E4%B8%9A%E5%AE%A3%E4%BC%A0new.png",
      alt: "底部"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section bottom-img section-7",
    attrs: {
      "data-section": "6"
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/6AEBS.png",
      alt: "底部"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section bottom-img section-8",
    attrs: {
      "data-section": "7"
    }
  }, [_c("img", {
    attrs: {
      src: "https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E5%95%86%E5%8A%A1%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88/7%E4%BB%93%E5%82%A8%E8%81%94%E7%9B%9F.png",
      alt: "底部"
    }
  })]);
}];
render._withStripped = true;